import { z } from 'zod';

import { RebindStatus } from '../admin/rebind';
import { DocumentNumberSchema, DocumentType } from '../admin/workers';
import { IsoDateTimeSchema } from '../common/datetime';
import { DeviceId, RebindRequestId } from '../common/ids';

import { DevicePlatform, DisplayMode, PublicKeyJwkSchema, UserAgentSchema } from './devices';
import { StaffMeSchema } from './me';

// ---------------------------------------------------------------------------
// Re-vinculación asistida (research R-6; contracts/staff-api.md · "Re-vinculación")
// ---------------------------------------------------------------------------

/**
 * `POST /rebind-requests` (pública): `{ document_type, document_number, public_key_jwk, platform,
 * display_mode, user_agent }`. Responde `202` siempre, exista o no el documento.
 */
export const RebindRequestBodySchema = z.object({
  document_type: DocumentType,
  document_number: DocumentNumberSchema,
  public_key_jwk: PublicKeyJwkSchema,
  platform: DevicePlatform,
  display_mode: DisplayMode,
  user_agent: UserAgentSchema,
});
export type RebindRequestBody = z.infer<typeof RebindRequestBodySchema>;

/** `202 { request_ref: 'rbq_…', expires_at }` (el `ref` es opaco; aleatorio si no hay worker). */
export const RebindRequestCreatedSchema = z.object({
  request_ref: RebindRequestId,
  expires_at: IsoDateTimeSchema,
});
export type RebindRequestCreated = z.infer<typeof RebindRequestCreatedSchema>;

/** Parámetro de ruta `{ref}` de `GET /rebind-requests/{ref}` y `POST /rebind-requests/{ref}/claim`. */
export const RebindRefParamsSchema = z.object({ ref: RebindRequestId });
export type RebindRefParams = z.infer<typeof RebindRefParamsSchema>;

/** `200 { status }` (`PENDING` también para refs desconocidas hasta 24 h; luego `EXPIRED`). */
export const RebindStatusResponseSchema = z.object({
  status: RebindStatus,
});
export type RebindStatusResponse = z.infer<typeof RebindStatusResponseSchema>;

/** `200 { device_id, me }` + Set-Cookie de `POST /rebind-requests/{ref}/claim` (firmado, sin cookie). */
export const ClaimResponseSchema = z.object({
  device_id: DeviceId,
  me: StaffMeSchema,
});
export type ClaimResponse = z.infer<typeof ClaimResponseSchema>;
